import { ControlType, HandoverKeys, LocationDog } from '../../../providers/ActivationObjectProvider/types'
import { WizzardStep3Form } from '../types'

export const DefaultValue: WizzardStep3Form = {
    locationDog: 'FreeOutside',
    handoverKeys: 'NotHandoverKeys',
    setControlChips: true,
    customerPresence: true,
    controlType: 'PerimeterControl',
    handoverDate: undefined,
    handoverHour: undefined,
}

export const LocationDogDesc: Record<LocationDog, string> = {
    FreeOutside: 'pes volně na pozemku',
    FreeInside: 'pes volně v budově',
    NotFree: 'pes vždy zajištěn',
    NotPresent: 'není',
}

export const HandoverKeysDesc: Record<HandoverKeys, string> = {
    LandAndObject: 'Na pozemek i od objektu',
    OnlyLand: 'Pouze na pozemek',
    NotHandoverKeys: 'Bez předání',
}

export const ControlTypeDesc: Record<ControlType, string> = {
    InsideControl: 'Vnitřní kontrola',
    SheathingControl: 'Plášťová kontrola',
    PerimeterControl: 'Obvodová kontrola',
    HalfControl: 'Poloviční kontrola',
}
